/**
 * Dynamic import functions for route-level code splitting.
 * Used by React.lazy in getRoutes/adminPages and idle route-chunk prefetch.
 */

export const loadExplorePage = () => import("../pages/ExplorePage");
export const loadTagDetailsPage = () => import("../pages/TagDetailsPage");
export const loadPersonDetailPage = () => import("../pages/PersonDetailPage");
export const loadPositionDetailPage = () =>
  import("../pages/PositionDetailPage");
export const loadPersonDetailLinkPage = () =>
  import("../pages/PersonDetailLinkPage");
export const loadTeamDetailPage = () => import("../pages/TeamDetailPage");
export const loadAIDashboards = () => import("../pages/AIDashboards");
export const loadAIDashboardsV2 = () => import("../pages/AIDashboardsV2");
export const loadAIDashboardLibrary = () =>
  import("../pages/AIDashboardLibrary");
export const loadTeamCanvasPage = () => import("../pages/TeamCanvasPage");
export const loadSlideDecksPage = () =>
  import("../pages/SlidesPage/SlideDecksPage");
export const loadSlideDeckPage = () =>
  import("../pages/SlidesPage/SlideDeckPage");
export const loadInsightsPage = () => import("../pages/InsightsPage");
export const loadPeopleSearchRedirect = () =>
  import("../pages/PeopleSearchRedirect");
export const loadWorkforcePage = () => import("../pages/WorkforcePage");
export const loadTeamListPage = () => import("../pages/TeamListPage");
export const loadSearchPage = () => import("src/pages/SearchPage");
export const loadWorkforcePlanningDashboard = () =>
  import("../pages/WorkforcePlanningDashboard");
export const loadGuardrailsHubPage = () =>
  import("../pages/WorkforceGuardrails/GuardrailsHubPage");
export const loadWorkforceInboxPage = () =>
  import("../pages/WorkforceInbox/WorkforceInboxPage");
export const loadGuardrailAdminPage = () =>
  import("../pages/WorkforceGuardrails/AdminPage");
export const loadTagsExplore = () => import("../pages/TagsExplore");
export const loadTeamsExplorer = () => import("../pages/TeamsExplorer");
export const loadGoalsExplorer = () => import("../pages/GoalsExplorer");
export const loadLogout = () => import("../pages/Logout");
export const loadApiDocs = () => import("../pages/ApiDocs");
export const loadLoginHistoryPage = () => import("../pages/LoginHistoryPage");
export const loadAuth0UserReport = () => import("src/pages/Auth0UserReport");
export const loadWorkflowsPage = () => import("../pages/WorkflowsPage");
export const loadWorkflowBuilderPage = () =>
  import("../pages/WorkflowBuilderPage");
export const loadDesignsHub = () => import("../pages/Designs/DesignsHub");
export const loadDesignDetailPage = () =>
  import("../pages/Designs/DesignDetailPage");
export const loadDesignEditPage = () =>
  import("../pages/Designs/DesignEditPage");
export const loadBambooHROAuthCallbackPage = () =>
  import("../pages/BambooHROAuthCallbackPage");
export const loadHomePageContainer = () =>
  import("../pages/HomePage/HomePageContainer");

export const loadBeforeCreateDatasourcesPage = () =>
  import("../pages/Datasource/BeforeCreateDatasourcesPage");
export const loadCreateDatasourcesPage = () =>
  import("../pages/Datasource/CreateDatasourcesPage");
export const loadCreateWorkspacePage = () =>
  import("../pages/Workspaces/CreateWorkspacePage");
export const loadDatasourcesPage = () =>
  import("../pages/Datasource/DatasourcesPage");
export const loadDatasourceDetailPage = () =>
  import("../pages/Datasource/DatasourceDetailPage");
export const loadDatasourceSelectPage = () =>
  import("../pages/Datasource/DatasourceSelectPage");
export const loadWorkspacesPage = () =>
  import("../pages/Workspaces/WorkspacesPage");
export const loadWorkspaceConfigurationPage = () =>
  import("../pages/Workspaces/ConfigurationPage");
export const loadInternalDashboard = () =>
  import("src/pages/InternalDashboard");
export const loadAdminConfiguration = () =>
  import("../pages/AdminConfiguration");
export const loadWorkspaceSettings = () => import("../pages/WorkspaceSettings");
export const loadOrgDesignSettingsPage = () =>
  import("../pages/OrgDesignSettings");
